import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchService } from '@sinequa/components/search';
import { AppService } from '@sinequa/core/app-utils';
import { Record } from "@sinequa/core/web-services";

@Component({
  selector: 'app-result-thumbnail',
  templateUrl: './result-thumbnail.component.html',
  styleUrls: ['./result-thumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultThumbnailComponent {

  @Input() record: Record;
  @Input() linkBehavior: "open" | "action" = "open";
  @Input() thumbnailColumn: string;
  @Input() defaultThumbnail: string;
  @Input() urlColumn = "url1";
  @Output() thumbnailClicked = new EventEmitter<boolean>();

  constructor(
    private appService: AppService,
    private searchService: SearchService) {
  }

  get thumbnailUrl(): string {
    let url = this.record[this.thumbnailColumn] // Custom column, if any
      || this.record.thumbnailUrl || this.record.originalUrl  || this.record.pdfUrl // Standard column
      || this.defaultThumbnail; // Default column
    return this.appService.updateUrlForCors(url);
  }

  get hasLinkBehaviour(): boolean {
    return this.linkBehavior === "open";
  }

  public get href(): string {
    return (this.hasLinkBehaviour && this.record[this.urlColumn]) || "#";
  }

  onImgError(event:any){
    event.target.src = './assets/def-src.webp'
   }

  public get target(): string {
    return (this.hasLinkBehaviour && this.record[this.urlColumn]) ? "_blank" : "_self";
  }

  public click(): boolean {
    const isLink = this.hasLinkBehaviour && !!this.record[this.urlColumn]; // true if this is a regular link (performs the default action)
    if (isLink)
      this.searchService.notifyOpenOriginalDocument(this.record);
    this.thumbnailClicked.emit(isLink); // Can be use to trigger actions
    return isLink;
  }
}


